import Vue from "vue";
import { post, fetch, Del, put } from "../../../../ask/axios";
import menberMenu from '../../../../components/userCenter/public/menberPageMenu.vue'
import { downloadFile, fileSteamDownload } from '@/utils/download'

const cityOptions = [];
export default {
  components: { menberMenu },
  data() {
    return {
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },

      //分页
      currentPage: 1, //当前页数
      pageSize: 20, //，每页显示的条数
      total: 0, //查询结果条数

      titNames: "Express shipment",
      titUrls: ",",
      //订单编号
      OrderNO: "",
      //订单开始日期
      OrderStartTime: new Date(new Date().setDate(new Date().getDate() - 30)),
      OrderEndTime: new Date(),
      //日期输入处理,结束日期不能大于开始日期
      pickerBeginDateBefore: {
        disabledDate: time => {
          if (this.OrderEndTime) {
            return time.getTime() > Date.now() || time.getTime() > this.OrderEndTime;
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      //日期输入处理，结束日期不能大于开始日期
      pickerBeginDateAfter: {
        disabledDate: time => {
          // console.log("time:" + this.OrderStartTime);
          let startDate = new Date(this.OrderStartTime);
          return time.getTime() < startDate.getTime() || time.getTime() > Date.now();
        }
      },


      addSendBox: false,
      showModal: false,
      Description: '',
      DescriptionMesg: '',

      //IsEffectiveAuu:true,
      // OredrExpTips:'请输入国内快递单号',
      // OredrxlTips:'请选择',


      //仓库地址信息
      shipAddress: '',
      //收货人名称
      recipient: '',
      //收货电话
      phoneNum: '',
      //收货仓库名称
      WarehouseName: '',

      // 提示
      weightPlaceholder: "单件重量",
      expCityPlaceholder: "请输入起运城市",
      expCountryPlaceholder: "请输入目的国家",
      expnumberholder: "相同件数",
      explongholder: "长",
      expwideholder: "宽",
      exptallholder: "高",
      exptypeGoodsItemholder: "",
      plaUnits: "总件数",
      palSumWeight: "总重量",
      palSumCBM: "总体积",

      //货物种类Id
      CargoTypeInfoIDs: "",
      //货物种类说明
      CargoTypeInfo: "",


      //验证文字颜色
      isCol: false,
      isCol2: false,
      isco13: false,

      statusChked: false,
      orderStatus: "9", //订单状态
      Orderstatus: "9", //订单下拉
      OrderStatusText: "", //订单状态text
      //交货方式text
      DeliveryTypeText: "",
      Statuswc: [{ value: "4", label: "Signed" }],

      //包裹类型
      wpxType: "",

      //渠道是否有价格
      isdobujg: false,



      //订单表格数据
      OrderListData: [],

      //复制货物信息数组
      radCargo: [{ Quanlity: "", Long: "", Wide: "", Height: "", Weight: "" }],
      sumUnits: "", //总件数,
      expWeight: "", //总重量输入框
      expCBM: "", //总体积输入框

      PrintId: '',  //打印标签id

      //是否点亮
      isTrue: false,

      ExpItemList: "",

      isDataNone: false, //是否有渠道数据
      isLoading: false, //加载中...
      isData: false,

      //订单状态 进行中
      statusOptions: [
        { value: "9", label: "Status" },
        { value: "1", label: "Receiving" },
        { value: "2", label: "Received" },
        { value: "3", label: "Delivered" }
      ],
      //订单状态 其他
      StatusStsrs: [
        { value: "9", label: "Status" },
        { value: "0", label: "Confirming" },
        { value: "5", label: "Returned" },
        { value: "6", label: "Canceled" }
      ],

      Statusarray: [1, 2, 3],

      //提示
      OrderPlaceholder: "Query with order number / tracking number / reference number",
      datetimePlaceholder: "Select date",
      IsState: "1", //1进行中  2 已完成 3 其他
      IsBut: "", //1导出订单 2 批量打印标签 3 批量打印发票 4 批量撤销
      currentPage4: 4, //分页
      checked: false,

      frameBg: false, //遮罩层
      trackIndex: false, //输入快递单号弹窗
      dupOrder: false, //复制订单弹框
      frameTips: false, //打印标签弹窗


      resource: '1',

      //自寄单号
      ExpTrackList: '',
      //所有自寄快递单号
      strExp: '',
      //快递公司
      // ExptrackVal:[
      //   {
      //     trackOptions:[
      //       { value: 1, label: "顺丰" },
      //       { value: 2, label: "圆通" },
      //       { value: 3, label: "申通" },
      //       { value: 4, label: "百世汇通" },
      //       { value: 5, label: "优速" },
      //       { value: 6, label: "德邦" },
      //       { value: 7, label: "EMS" },
      //       { value: 8, label: "速尔" },
      //       { value: 9, label: "宅急送" },
      //       { value: 10, label: "天天快递" },
      //       { value: 11, label: "中通" },
      //       { value: 12, label: "其他" }
      //     ],
      //     ExpressCompany: "",
      //     CourierNO:''
      //   }
      // ],
      Expid: '',
      information: '',
      startExpCode: "", //起运城市
      desExpCode: "", //目的国家
      ChannelKey: "", //渠道Key
      decCountryKey: '', //国家key


      generalCargoID: '139', //普货ID
      porCargoID: '111', //移动电源ID
      batteryCargoID: '103', //纯电池ID


      cargoRadio: null,

      checkAll: false,
      //复制选中的货物种类
      checkedCities: [],
      CitiesID: [],
      //复制过来的货物种类信息
      cities: cityOptions,
      isIndeterminate: true,
      //复制违禁品声明
      chkTips: false,


    };
  },

  created() {
    //创建后
    if (this.$route.query.Status) {
      this.Orderstatus = this.$route.query.Status
      this.Statusarray = [this.Orderstatus];
    } else {
      this.Orderstatus = "9";
    }
  },
  mounted() {
    //载入dom后周期函数

    //this.datetime();
    this.InquireBut();



  },
  watch: {},
  computed: {
    //计算属性周期函数

    // sumUnits: "", //总件数,
    //   expWeight: "", //总重量输入框
    //   expCBM: "", //总体积输入框
    //按每件包裹计算
    totalNum() {
      //sumUnits:'',sumKG:'',sumCBM:'',//总件数、总重量、总体积
      let num = null;
      if (this.radCargo) {
        this.radCargo.forEach(e => {
          num += parseInt(e.Quanlity);
        });
        if (isNaN(num)) {
          this.sumUnits = 0;
          return 0;
        }
        this.sumUnits = num;
        return num;
      }
    },
    totalKG() {
      let num = 0;
      this.radCargo.forEach(e => {
        return (num += e.Quanlity * e.Weight);
      });
      this.expWeight = num;
      return num;
    },
    totalCBM() {
      let num = 0;
      if (this.radCargo) {
        this.radCargo.forEach(e => {
          num += ((e.Long * e.Wide * e.Height) / 1000000) * e.Quanlity;
        });
        this.expCBM = num;
        return num;
      }
    }
  },
  methods: {

    /*================分页开始==========================*/
    handleSizeChange(val) {
      this.pageSize = val

      this.statusChked = false;
      this.SelectOrder()
      //bus.$emit('stripNum',val)


    },
    handleCurrentChange(val) {
      this.currentPage = val;

      this.statusChked = false;
      this.SelectOrder()
      //bus.$emit('CurrentPage',val)

    },
    //查询按钮
    InquireBut() {
      this.currentPage = 1
      this.SelectOrder();
    },
    //进行中查询
    underwayBut() {
      this.Orderstatus = "9"
      //传入进行中的所有订单状态
      this.Statusarray = [1, 2, 3];
      this.InquireBut();
      this.IsState = "1";
      //更换清空按钮使用状态
      this.statusChked = false;
      this.isTrue = false;

    },
    //已完成查询
    StocksBut() {
      this.Orderstatus = "4"
      this.Statusarray = [4];
      this.InquireBut();
      this.IsState = "2";
      //更换清空按钮使用状态
      this.statusChked = false;
      this.isTrue = false;
    },
    //其他查询
    restsBut() {
      this.Orderstatus = "9"
      this.Statusarray = [0, 5, 6];
      this.InquireBut();
      this.IsState = "3";
      //更换清空按钮使用状态
      this.statusChked = false;
      this.isTrue = false;
    },
    //导出订单
    ExportOrder() {
      this.IsBut = "1";
      this.ExportOrderAPI();
    },
    ExportOrderAPI() {
      let that = this;
      let date1 = new Date(that.OrderStartTime).Format("yyyy-MM-dd");
      let date2 = new Date(that.OrderEndTime).Format("yyyy-MM-dd");
      that.OrderStartTime = date1;
      that.OrderEndTime = date2;
      if (this.OrderEndTime.length < 11) {
        this.OrderEndTime = `${this.OrderEndTime} 23:59:59`
      }
      that.api.param = {
        Status: that.Statusarray, //默认查询   查询进行中的所有状态
        CreateTimeStart: that.OrderStartTime,
        CreateTimeEnd: that.OrderEndTime
      };
      if (that.OrderNO != "" || that.OrderNO != null) {
        that.api.param["MixOrderNO"] = that.OrderNO;
      }
      // that.api.url = that.$api02 + "/api/EbayCustomer/ExpOrder/ExportExpOrderList";
      that.api.url = that.$api04 + "/Express/api/ExpOrder/ExportExpOrderList";
      post(that.api.url, that.api.param).then(function (res) {
        if (res.ErrorCode == 'C0001') {
          let Name = 'Express orders_' + date2 + '.xls'
          let url = res.Results.url
          // console.log(url, res.Results.url.indexOf('/'), "url");
          // downloadFile(url, Name)
          // window.location.href = url
          fileSteamDownload(that, {
            FullPath: url, // 路径
            CurrentFileName: Name // 文件名称
          }, Name)
          // that.downloadFileYun(url, Name)
        }
      })
    },
    // downloadFileYun(urlFire, fileName) {
    //   let params = {
    //     FullPath: urlFire,
    //     CurrentFileName: fileName
    //   }
    //   let url = this.$api04 + '/File/api/FileHandle/Download'
    //   fetch(url, params).then((res) => {
    //     console.log(5644655);
    //   })
    // },
    //批量撤销
    BatchRevocation() {
      let that = this;
      this.IsBut = "4";

      let info = []
      let isShowTips = false
      that.OrderListData.forEach(e => {
        //info.push(e.T_TD_ExpOrderWaybillNO) 
        if (e.checked == true && e.Status == 0) {
          info.push(e.T_TD_ExpOrderWaybillNO)
        } else if (e.checked == true && (e.Status == 5 || e.Status == 6)) {
          isShowTips = true
          return false
        }
      })
      //如果批量撤销中有不是未确认的订单
      if (isShowTips == true) {
        this.$confirm("Only the orders that are not confirmed can be cancelled. Please choose again!", "Cancel the order", {
          customClass: "custom-message-box", //自定义添加Class
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
          closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
          showCancelButton: false,//去掉取消按钮
          //showClose:false,//去掉右上角的取消（X）
          // type: 'warning',
          center: true
        }).then(() => {
          //this.RevocationApI(info);
        }).catch(() => { });
        return false;
      } else if (isShowTips == false) {
        this.$confirm("Are you sure you want to cancel the selected order?", "Cancel the order", {
          customClass: "custom-message-box", //自定义添加Class
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
          closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
          // showCancelButton:false,//去掉取消按钮
          //showClose:false,//去掉右上角的取消（X）
          // type: 'warning',
          center: true
        }).then(() => {
          this.RevocationApI(info);
        }).catch(() => { });
        return false;
      }

    },
    //撤销Api
    RevocationApI(IdArray) {
      let that = this;
      that.api.param = {
        WaybillNOs: IdArray
      }
      //that.api.url = that.$api03 + "/api/TradeCustomer/ExpOrderHandle/RevokedOrders";
      that.api.url = that.$api04 + "/ExpressBehand/api/ExpOrderHandle/RevokedOrders";
      post(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK) {

        } else {

          if (res.Message != null || res.Message != "") {
            that.$confirm('failed!', "", {
              customClass: "tipsBtn custom-message-box", //自定义添加Class
              dangerouslyUseHTMLString: true, //使用html
              confirmButtonText: "Confirm",
              cancelButtonText: "Cancel",
              cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
              closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
              showCancelButton: false,//去掉取消按钮
              showClose: false,//去掉右上角的取消（X）
              // type: 'warning',
              center: true
            }).then(() => {

            }).catch(() => { });
          }

        }

        that.InquireBut();
      })
    },
    //撤销
    Revocation(item) {
      let Idarrary = [
        item.T_TD_ExpOrderWaybillNO
      ];
      this.$confirm("Are you sure you want to cancel the  selected order?", "Cancel the order", {
        customClass: "custom-message-box", //自定义添加Class
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
        closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
        // showCancelButton:false,//去掉取消按钮
        //showClose:false,//去掉右上角的取消（X）
        // type: 'warning',
        center: true
      }).then(() => {
        this.RevocationApI(Idarrary);
      }).catch(() => { });
      return false;
    },
    getClose() {
      this.showModal = false
      this.addSendBox = false
      this.DescriptionMesg = ''
    },
    //截单操作
    OrderCut(item) {
      this.information = item;
      this.showModal = true
      this.addSendBox = true
    },
    //截单操作API
    OrderCutAPI(id) {
      let that = this;
      if (that.Description == '' || that.Description == null) {
        that.DescriptionMesg = 'Required'
        return false
      }
      that.api.param = {
        WaybillNO: id,
        IsDetention: 1,
        Description: that.Description
      };
      that.api.url =
       // that.$api03 + "/api/TradeCustomer/ExpOrderHandle/UpdateIsDetention ";
        that.$api04 + "/ExpressBehand/api/ExpOrderHandle/UpdateIsDetention";
      post(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.$confirm("successfully", "", {
            customClass: "custom-message-box", //自定义添加Class
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
            closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
            showCancelButton: false, //去掉取消按钮
            showClose: false, //去掉右上角的取消（X）
            center: true
          }).then(() => {
            that.InquireBut();
            that.showModal = false
            that.addSendBox = false
            that.Description = ''
          })
            .catch(() => { });
          return false;
        }
      });
    },

    //验证渠道是否有效
    SelectChannel(ChannelKey, DestCountryKey) {
      return new Promise(resolve => {
        let that = this
        that.api.param = {
          channelKey: ChannelKey,
          countryKey: DestCountryKey
        }
        //that.api.url = this.$api01 + "/api/InfoCustomer/ExpChannel/IsChannelCanOrder";
        that.api.url = this.$api04 + "/Express/api/ExpChannel/IsChannelCanOrder";
        fetch(that.api.url, that.api.param).then(function (res) {
          if (res.Results == true) {
            resolve(res.Results);
          } else {
            that.$confirm("This channel has expired!", "", {
              customClass: "custom-message-box", //自定义添加Class
              confirmButtonText: "Confirm",
              cancelButtonText: "Cancel",
              cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
              closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
              showCancelButton: false, //去掉取消按钮
              showClose: false, //去掉右上角的取消（X）
              // type: 'warning',
              center: true
            }).then(() => {

            }).catch(() => {

            });
            return false;
          }
        })
      })
    },
    //编辑订单操作
    EditOrder(item) {
      this.SelectChannel(item.ChannelKey, item.DestCountryKey).then(Results => { //验证渠道是否有效
        if (Results == true) {
          window.location.href = "/exp/expEdit?ord=" + item.T_TD_ExpOrderWaybillNO;
        }
      })
    },
    PrintLabel(id) {
      this.showModal = true;
      this.frameTips = true;
      this.PrintId = id;
    },
    closePrint() {
      this.frameTips = false;
      // console.log('01'+this.resource)
    },
    //打印标签
    PrintLabelAPI() {
      let that = this;
      //订单号
      var wayBillNOs = that.PrintId;
      var prePage = window.open();
      if (this.resource == '1') {
        var width = 210;
        var height = 297;
      } else {
        var width = 100;
        var height = 90;
      }
      that.api.param = {
        Width: width,
        Height: height,
        WaybillNo: wayBillNOs,
        WaybillType: 1
      };
      that.api.url = this.$api05 + "/api/Make/PDFLable";
      post(that.api.url, that.api.param).then(function (res) {
        if (res.ResultCode == 1) {
          // prePage.location.href = that.$apiFileCloud + (res.Data.indexOf('/') === 0 ? '' : '/') + res.Data;
          prePage.location.href = res.Data;
        }
      })
    },
    //打印发票
    PrintInvoice(item) {
      //打印发票操作
      let conInfo = [];
      if (item.InvoiceType == 4) {
        conInfo.push({ ord: item.Id, CusInvoicePath: item.CusInvoicePath })
      }
      let conInfos = JSON.stringify(conInfo)

      let newOpen = window.open();
      newOpen.location.href = this.$apiEn + 'exp/printInvoice?conInfos=' + conInfos;
    },

    //下拉选择查询
    StatusSelect() {
      if (this.Orderstatus == "9" && this.IsState == "1") {
        this.underwayBut();
      } else if (this.Orderstatus == "9" && this.IsState == "2") {
        this.StocksBut();
      } else if (this.Orderstatus == "9" && this.IsState == "3") {
        this.restsBut();
      } else {
        this.Statusarray = [this.Orderstatus];
        this.InquireBut();
      }
    },
    //查询订单信息接口
    SelectOrder() {
      let that = this;
      //是否购买保险  0  不购买   1 购买   -1查询所有  默认为0
      let IsInsurance = -1;
      // let date1 = that.formatDate(that.OrderStartTime, "yyyy-MM-dd");
      // let date2 = that.formatDate(that.OrderEndTime, "yyyy-MM-dd");

      let date1 = new Date(that.OrderStartTime).Format("yyyy-MM-dd");
      let date2 = new Date(that.OrderEndTime).Format("yyyy-MM-dd");

      that.OrderStartTime = !that.OrderStartTime ? '' : date1;
      that.OrderEndTime = !that.OrderEndTime ? '' : date2;


      that.api.param = {
        Status: that.Statusarray, //默认查询   查询进行中的所有状态
        CreateTimeStart: that.OrderStartTime,
        CreateTimeEnd: that.OrderEndTime,
        IsInsurance: IsInsurance,
        skip: (that.currentPage - 1) * that.pageSize,
        take: that.pageSize,
        Origin: 1
      };
      if (that.OrderNO != "" || that.OrderNO != null) {
        that.api.param["MixOrderNO"] = that.OrderNO;
      }
      that.isLoading = true; //加载中...
      that.isDataNone = false; //没有数据查无订单
      that.isData = false; //有数据列表

      that.api.url = that.$api03 + "/api/TradeCustomer/ExpNewOrder/QueryOrder";
      post(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.isLoading = false;
          that.isData = true;
          if (res.Results) {
            if (res.Results.length < 0 || res.Results.length == 0) {
              that.isDataNone = true;
              that.isDataNone != that.isLoading;
            } else {
              that.isDataNone = false;
            }
          }
        } else {
          that.isLoading = false;
          that.isDataNone = true;
        }

        that.OrderListData = res.Results;
        if (that.OrderListData) {
          that.OrderListData.forEach((item) => {
            Vue.set(item, 'checked', false)
          })
        }

        that.total = res.Total;
      });
    },
    //全选
    chkAllEvent(val) {
      var that = this;
      that.OrderListData.forEach(function (chk) {
        chk.checked = that.statusChked;
      });
      if (that.statusChked) {
        that.isTrue = true;
      } else {
        that.isTrue = false;
      }
    },
    //单选
    chkStatusEvent() {
      let that = this;
      var select = that.OrderListData.filter(function (chk, k) {
        return chk.checked == true;
      });

      select.length == that.OrderListData.length
        ? (that.statusChked = true)
        : (that.statusChked = false);
      if (select.length > 0) {
        that.isTrue = true;
      } else {
        that.isTrue = false;
      }
    },

    //时间格式转换
    // formatDate(date, strFormat) {
    //   if (date == "" || date == null) {
    //     return;
    //   }
    //   if (typeof date === "string") {
    //     date = new Date(date);
    //   }
    //   var o = {
    //     "M+": date.getMonth() + 1, //月份
    //     "d+": date.getDate(), //日
    //     "H+": date.getHours(), //小时
    //     "m+": date.getMinutes(), //分
    //     "s+": date.getSeconds(), //秒
    //     "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    //     S: date.getMilliseconds() //毫秒
    //   };
    //   if (/(y+)/.test(strFormat))
    //     strFormat = strFormat.replace(
    //       RegExp.$1,
    //       (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    //     );
    //   for (var k in o)
    //     if (new RegExp("(" + k + ")").test(strFormat))
    //       strFormat = strFormat.replace(
    //         RegExp.$1,
    //         RegExp.$1.length == 1
    //           ? o[k]
    //           : ("00" + o[k]).substr(("" + o[k]).length)
    //       );
    //   return strFormat;
    // },
    //订单状态转换
    StatusName(code) {
      if (code == "0") return "Confirming";
      if (code == "1") return "Receiving";
      if (code == "2") return "Received";
      if (code == "3") return "Delivered";
      if (code == "4") return "Completed";
      if (code == "5") return "Returned";
      if (code == "6") return "Canceled";

    },
    //轨迹图片显示
    imgUrl(id) {
      if (id == 0 || id == 6 || id == 5) return "../../../static/img/listIcon0.png";
      if (id == 1) return "../../../static/img/listIcon1.png";
      if (id == 2 || id == 3) return "../../../static/img/listIcon2.png";
      if (id == 4) return "../../../static/img/listIcon3.png";
    },

    //关闭弹窗
    closeBox() {
      //渠道可以走的货物
      this.checkedCities = [];
      //订单过来的货物种类
      this.Cities = [];
      //违禁品声明
      this.chkTips = false;
      this.frameBg = false;
      this.trackIndex = false;
      this.frameTips = false;
      this.dupOrder = false;
      this.showModal = false;
    },
    //跳转取件单详情页面
    Sheet(code) {
      var newWin = window.open();
      newWin.location.href = "/PickupDetails?billno=" + code;
    },
    //打开详情页面
    goExpListDetails(id) {
      this.$router.push({
        path: "/exp/expDetails",
        query: {
          "ord": id,
          "news": 0
        }
      });
      // var newWin = window.open();
      // newWin.location.href = "/exp/expDetails?ord=" + id+'&news=0';
    },
    goExpListOrder(item) {
      let that = this;
      let carinfo = ''; //货物种类名称
      let carId = that.CitiesID.join(','); //货物种类IdS
      for (var i = 0; i < that.CitiesID.length; i++) {
        let carIndex = that.CitiesID[i]
        that.checkedCities.forEach(e => {
          if (e.id == carIndex) {
            carinfo += e.item + ',';
          }
        })
      }
      that.api.param = {
        //"CustomerID": 0,
        ChannelKey: item.ChannelKey,
        StartCityKey: item.StartCityKey,
        StartCityNameEn: item.StartCityNameEn, // 起运城市英文名称
        StartCityName: item.StartCityName,
        DestCountrKey: item.DestCountryKey,
        DestCountryName: item.DestCountryName,
        DestCountryNameEn: item.DestCountryNameEn,
        QueryType: that.cargoRadio, //1:按每件，2：按总量 ,
        PackageType: that.wpxType, //包裹类型
        ModeCode: item.ModeCode, // 运输方式
        IsCopy: true,
        WaybillNO: item.T_TD_ExpOrderWaybillNO,
        CargoIDs: carId,
        CargoDescs: carinfo,
        OrderCount: that.sumUnits,
        OrderWeight: that.expWeight,
        OrderVolume: that.expCBM,
        GoodValue: "", //申报价值
        OrderVolumeInfos: that.radCargo,
        OrderExtraFeeInfos: item.FeeInfo,
        ChannelOwnerType: item.ChannelOwnerType,
        QueryStartCityKey:item.QueryStartCityKey,
        QueryStartCityName:item.QueryStartCityName,
        QueryStartCityNameEn:item.QueryStartCityNameEn,
      };
      var newWin = window.open();
      that.api.url =
        // this.$api03 + "/api/TradeCustomer/ExpNewOrder/AddNotConfirmOrder";
        this.$api04 + "/Express/api/ExpNewOrder/AddNotConfirmOrder";
      post(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          newWin.location.href = "/exp/expEdit?ord=" + res.Results;
        } else if (res.IsOK == false) {
          newWin.close();
        }
      });
    },
    //鼠标放入事件
    SelectExpList(id) {
      this.strExp = '';
      this.SelectExpNo(id);
    },
    //材积信息接口数据
    getExpOrderVolume(id) {
      let that = this;
      //that.api.url = that.$api03 + "/api/TradeCustomer/ExpOrder/QueryExpOrderVolume";
      that.api.url = that.$api04 + "/Express/api/ExpOrder/QueryExpOrderVolume";
      that.api.param = {
        waybillNO: id
      };
      fetch(that.api.url, that.api.param).then(function (res) {
        // console.log('货物信息：'+JSON.stringify(res))
        if (res.IsOK) {
          that.radCargo = res.Results;
        }
      });
    },
    getlisthwzl(item) {
      let that = this;
      //that.api.url = that.$api01 + "/api/InfoCustomer/ExpChannel/GetExpChannel";
      that.api.url = that.$api04 + "/Express/api/ExpChannel/GetExpChannel";
      that.api.param = {
        channelKey: item.ChannelKey,
        countryKey: item.DestCountryKey
      };
      fetch(that.api.url, that.api.param).then(function (res) {
        // console.log('货物信息：'+JSON.stringify(res))
        if (res.IsOK) {
          that.CargoTypeInfoIDs = res.Results.CargoTypeInfoIDs;
          that.CargoTypeInfo = res.Results.CargoTypeInfo;
          let infoValInfo = [{ id: "", item: "" }];
          let infoVal = that.CargoTypeInfoIDs.split(",");
          var newinfoVal = that.CargoTypeInfo.split(",");
          for (var i = 0; i < newinfoVal.length; i++) {
            that.checkedCities.push({ id: infoVal[i], item: newinfoVal[i] });
          }
        }
      });
    },

  }
};



// WEBPACK FOOTER //
// ./src/assets/js/userCenter/exp/expList.js